import oget from 'oget';

import { ROUND_SELECT } from '../actions/round';
import { HEAT_SELECT } from '../actions/heat';
import { CONTESTS_SHOW_SUCCESS } from '../actions/contests';

const defaultState = null;

export default (state = defaultState, { type, payload = {} }) => {
  switch (type) {
    case ROUND_SELECT: {
      const liveHeat = oget(payload.round, 'liveHeat', {});
      return oget(liveHeat, 'externalId', null);
    }

    case HEAT_SELECT: {
      return oget(payload, 'externalId', null);
    }

    case CONTESTS_SHOW_SUCCESS: {
      if (payload.selectedHeatId === state) {
        return state;
      }

      const { selectedRound } = payload;
      return oget(selectedRound, 'heats[0].externalId', null);
    }

    default: {
      return state;
    }
  }
};
